import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KindService } from 'app/services/models/kind.service';
import { ReferenceService } from 'app/services/models/reference.service';
import { MeasurementResultService } from 'app/services/models/measurement-result.service';
import { ToastrService } from 'ngx-toastr';
import { ReferenceTransactionsComponent } from '../reference-transactions/reference-transactions.component';

@Component({
  selector: 'app-measurement-result-dialog',
  templateUrl: './measurement-result-dialog.component.html',
  styleUrls: ['./measurement-result-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MeasurementResultDialogComponent implements OnInit {
  @Input() data;
  measurementResult: FormGroup;
  kinds: any[] = [];
  references: any[] = [];
  selectedFile: File | null = null;
  isSubmitting = false;

  existingFileName: string = "";
  existingFilePath: string = "";

  isGeneralOpen: boolean = true; // İlk başta açık olsun
  isCompanyOpen: boolean = false;
  isDeviceOpen: boolean = false;
  isReferenceListOpen: boolean = false;

  constructor(
    private ngModal: NgbActiveModal,
    private fb: FormBuilder,
    private kindService: KindService,
    private referenceService: ReferenceService,
    private measurementResultService: MeasurementResultService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) { }

  async ngOnInit() {
    this.measurementResult = this.fb.group({
      kindId: [null, Validators.required],
      referenceId: [null],

      // =====================================
      // 1. FİRMA BİLGİLERİ (Tek Hücre Konumları)
      // =====================================
      // FIRMA ADI
      companyNameTargetSheetName: [null],
      companyNameStartRow: [null],
      companyNameStartColumn: [null],

      // ADRES
      companyAdresTargetSheetName: [null],
      companyAdresStartRow: [null],
      companyAdresStartColumn: [null],

      // =====================================
      // 2. CİHAZ BİLGİLERİ (Tek Hücre Konumları)
      // =====================================
      // CİHAZ ADI
      deviceNameTargetSheetName: [null],
      deviceNameStartRow: [null],
      deviceNameStartColumn: [null],

      // SERİ NO
      seriNoTargetSheetName: [null],
      seriNoStartRow: [null],
      seriNoStartColumn: [null],

      // ÇÖZÜNÜRLÜK
      resolutionTargetSheetName: [null],
      resolutionStartRow: [null],
      resolutionStartColumn: [null],

      // ENVANTER NO
      inventoryNumberTargetSheetName: [null],
      inventoryNumberStartRow: [null],
      inventoryNumberStartColumn: [null],

      // TÜR ADI
      kindNameTargetSheetName: [null],
      kindNameStartRow: [null],
      kindNameStartColumn: [null],

      // =====================================
      // 3. REFERANS CİHAZLAR LİSTESİ AYARLARI (Granüler)
      // =====================================
      // Cihaz Adı
      referenceDeviceNameTargetSheetName: [null],
      referenceDeviceNameStartRow: [null],
      referenceDeviceNameStartColumn: [null],

      // Seri No
      referenceDeviceSeriNoTargetSheetName: [null],
      referenceDeviceSeriNoStartRow: [null],
      referenceDeviceSeriNoStartColumn: [null],

      // Kabul Kriteri
      referenceDeviceAcceptanceTargetSheetName: [null],
      referenceDeviceAcceptanceStartRow: [null],
      referenceDeviceAcceptanceStartColumn: [null],

      // Belirsizlik
      referenceDeviceUncertaintyTargetSheetName: [null],
      referenceDeviceUncertaintyStartRow: [null],
      referenceDeviceUncertaintyStartColumn: [null],
    });

    this.measurementResult.addValidators(
      this.rowRequiredIfAnyFilled(
        'companyNameTargetSheetName',
        'companyNameStartRow',
        'companyNameStartColumn'
      )
    );
    this.measurementResult.addValidators(
      this.rowRequiredIfAnyFilled(
        'companyAdresTargetSheetName',
        'companyAdresStartRow',
        'companyAdresStartColumn'
      )
    );
    this.measurementResult.addValidators(
      this.rowRequiredIfAnyFilled(
        'deviceNameTargetSheetName',
        'deviceNameStartRow',
        'deviceNameStartColumn'
      )
    );
    this.measurementResult.addValidators(
      this.rowRequiredIfAnyFilled(
        'seriNoTargetSheetName',
        'seriNoStartRow',
        'seriNoStartColumn'
      )
    );
    this.measurementResult.addValidators(
      this.rowRequiredIfAnyFilled(
        'resolutionTargetSheetName',
        'resolutionStartRow',
        'resolutionStartColumn'
      )
    );
    this.measurementResult.addValidators(
      this.rowRequiredIfAnyFilled(
        'inventoryNumberTargetSheetName',
        'inventoryNumberStartRow',
        'inventoryNumberStartColumn'
      )
    );
    this.measurementResult.addValidators(
      this.rowRequiredIfAnyFilled(
        'kindNameTargetSheetName',
        'kindNameStartRow',
        'kindNameStartColumn'
      )
    );
    this.measurementResult.addValidators(
      this.rowRequiredIfAnyFilled(
        'referenceDeviceNameTargetSheetName',
        'referenceDeviceNameStartRow',
        'referenceDeviceNameStartColumn'
      )
    );
    this.measurementResult.addValidators(
      this.rowRequiredIfAnyFilled(
        'referenceDeviceSeriNoTargetSheetName',
        'referenceDeviceSeriNoStartRow',
        'referenceDeviceSeriNoStartColumn'
      )
    );
    this.measurementResult.addValidators(
      this.rowRequiredIfAnyFilled(
        'referenceDeviceAcceptanceTargetSheetName',
        'referenceDeviceAcceptanceStartRow',
        'referenceDeviceAcceptanceStartColumn'
      )
    );
    this.measurementResult.addValidators(
      this.rowRequiredIfAnyFilled(
        'referenceDeviceUncertaintyTargetSheetName',
        'referenceDeviceUncertaintyStartRow',
        'referenceDeviceUncertaintyStartColumn'
      )
    );

    if (this.data != null) {
      await this.getByIdMeasurementResult(this.data);
    }

    await this.getAllKinds();
    await this.getAllReferences();
    this.measurementResult.get('kindId')?.valueChanges.subscribe(async (kindId) => {
      await this.getAllReferences(kindId);          // seçilen türün referanslarını getir
      this.measurementResult.get('referenceId')?.setValue(null); // referansı resetle
    });
  }

  hasRowError(sheetField: string): boolean {
    const errors = this.measurementResult.errors;
    if (!errors || !errors['rowIncomplete']) return false;

    return errors['rowIncomplete'].sheetField === sheetField;
  }

  rowRequiredIfAnyFilled(
    sheetField: string,
    rowField: string,
    colField: string
  ): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const sheet = group.get(sheetField)?.value;
      const row = group.get(rowField)?.value;
      const col = group.get(colField)?.value;

      const anyFilled = !!sheet || !!row || !!col;

      if (!anyFilled) {
        // satır tamamen boş → OK
        return null;
      }

      const allFilled = !!sheet && !!row && !!col;

      return allFilled
        ? null
        : {
          rowIncomplete: {
            sheetField,
            rowField,
            colField
          }
        };
    };
  }


  async getByIdMeasurementResult(id) {
    const res = await this.measurementResultService.getByIdMeasurementResult(id);
    console.log(res);
    if (!res) return;

    // Formu doldur
    this.measurementResult.patchValue({
      kindId: res.kindId,
      referenceId: res.referenceId
    });
    if (res.excelWriteConfig) {
      try {
        // JSON string'i parse et
        const config = JSON.parse(res.excelWriteConfig);

        // Ayrıştırılan değerleri form alanlarına yama (patchValue)
        if (config != null) {
          this.measurementResult.patchValue({
            // =====================================
            // 1. FİRMA BİLGİLERİ (Tek Hücre Konumu)
            // =====================================
            // FIRMA ADI
            companyNameTargetSheetName: config?.CompanyNameTargetSheetName,
            companyNameStartRow: config?.CompanyNameStartRow,       // DTO'dan gelen StartRow
            companyNameStartColumn: config?.CompanyNameStartColumn, // DTO'dan gelen StartColumn

            // ADRES
            companyAdresTargetSheetName: config?.CompanyAdresTargetSheetName,
            companyAdresStartRow: config?.CompanyAdresStartRow,     // DTO'dan gelen StartRow
            companyAdresStartColumn: config?.CompanyAdresStartColumn, // DTO'dan gelen StartColumn

            // =====================================
            // 2. CİHAZ BİLGİLERİ (Tek Hücre Konumu)
            // =====================================

            // CİHAZ ADI
            deviceNameTargetSheetName: config?.DeviceNameTargetSheetName,
            deviceNameStartRow: config?.DeviceNameStartRow,
            deviceNameStartColumn: config?.DeviceNameStartColumn,

            // SERİ NO
            seriNoTargetSheetName: config?.SeriNoTargetSheetName,
            seriNoStartRow: config?.SeriNoStartRow,
            seriNoStartColumn: config?.SeriNoStartColumn,

            // ÇÖZÜNÜRLÜK
            resolutionTargetSheetName: config?.ResolutionTargetSheetName,
            resolutionStartRow: config?.ResolutionStartRow,
            resolutionStartColumn: config?.ResolutionStartColumn,

            // ENVANTER NO
            inventoryNumberTargetSheetName: config?.InventoryNumberTargetSheetName,
            inventoryNumberStartRow: config?.InventoryNumberStartRow,
            inventoryNumberStartColumn: config?.InventoryNumberStartColumn,

            // TÜR ADI
            kindNameTargetSheetName: config?.KindNameTargetSheetName,
            kindNameStartRow: config?.KindNameStartRow,
            kindNameStartColumn: config?.KindNameStartColumn,

            // =====================================
            // 3. REFERANS CİHAZLAR (Granüler)
            // =====================================

            // CİHAZ ADI
            referenceDeviceNameTargetSheetName: config?.ReferenceDeviceNameTargetSheetName,
            referenceDeviceNameStartRow: config?.ReferenceDeviceNameStartRow,
            referenceDeviceNameStartColumn: config?.ReferenceDeviceNameStartColumn,

            // SERİ NO
            referenceDeviceSeriNoTargetSheetName: config?.ReferenceDeviceSeriNoTargetSheetName,
            referenceDeviceSeriNoStartRow: config?.ReferenceDeviceSeriNoStartRow,
            referenceDeviceSeriNoStartColumn: config?.ReferenceDeviceSeriNoStartColumn,

            // KABUL KRİTERİ
            referenceDeviceAcceptanceTargetSheetName: config?.ReferenceDeviceAcceptanceTargetSheetName,
            referenceDeviceAcceptanceStartRow: config?.ReferenceDeviceAcceptanceStartRow,
            referenceDeviceAcceptanceStartColumn: config?.ReferenceDeviceAcceptanceStartColumn,

            // BELİRSİZLİK
            referenceDeviceUncertaintyTargetSheetName: config?.ReferenceDeviceUncertaintyTargetSheetName,
            referenceDeviceUncertaintyStartRow: config?.ReferenceDeviceUncertaintyStartRow,
            referenceDeviceUncertaintyStartColumn: config?.ReferenceDeviceUncertaintyStartColumn,
          });
        }
      } catch (e) {
        console.error("ExcelWriteConfig JSON ayrıştırma hatası:", e);
        this.toastr.error("Konfigürasyon verisi okunamadı.");
      }
    }
    // Eski dosya bilgileri sakla
    this.existingFileName = res.fileName;
    this.existingFilePath = res.filePath;

    // Seçili türün referanslarını çek
    await this.getAllReferences(res.kindId);
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 100, 13);
    this.kinds = data.types || [];
  }

  async getAllReferences(kindId?: number) {
    const data = await this.referenceService.getAllReference(0, 1000, kindId);
    this.references = data.references || [];
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
    }
  }

  async saveMeasurementResult() {
    if (this.measurementResult.invalid) return;
    this.isSubmitting = true;

    const formData = new FormData();

    // Ortak zorunlu alan -> sadece kindId
    formData.append('KindId', this.measurementResult.value.kindId);

    // ReferenceId zorunlu değil
    formData.append('ReferenceId', this.measurementResult.value.referenceId ?? null);

    // 🟢 CREATE (yeni ekleme): Dosya zorunlu
    if (!this.data) {
      if (!this.selectedFile) {
        this.toastr.error("Lütfen bir dosya yükleyin.");
        this.isSubmitting = false;
        return;
      }

      formData.append('formFile', this.selectedFile, this.selectedFile.name);
    }

    // 🟡 UPDATE (güncelleme): Dosya zorunlu değil
    else {
      formData.append('Id', this.data);

      // Yeni dosya seçildiyse gönder
      if (this.selectedFile) {
        formData.append('formFile', this.selectedFile, this.selectedFile.name);
      }
      // Yeni dosya seçilmediyse sadece kindId ve referenceId güncellenecek
    }
    // =====================================
    // 1. FİRMA BİLGİLERİ
    // =====================================
    // FIRMA ADI
    if (this.measurementResult.value.companyNameTargetSheetName) {
      formData.append('ExcelWriteConfigDto.CompanyNameTargetSheetName', this.measurementResult.value.companyNameTargetSheetName);
    }
    if (this.measurementResult.value.companyNameStartRow) {
      formData.append('ExcelWriteConfigDto.CompanyNameStartRow', this.measurementResult.value.companyNameStartRow);
    }
    if (this.measurementResult.value.companyNameStartColumn) {
      formData.append('ExcelWriteConfigDto.CompanyNameStartColumn', this.measurementResult.value.companyNameStartColumn);
    }

    // ADRES
    if (this.measurementResult.value.companyAdresTargetSheetName) {
      formData.append('ExcelWriteConfigDto.CompanyAdresTargetSheetName', this.measurementResult.value.companyAdresTargetSheetName);
    }
    if (this.measurementResult.value.companyAdresStartRow) {
      formData.append('ExcelWriteConfigDto.CompanyAdresStartRow', this.measurementResult.value.companyAdresStartRow);
    }
    if (this.measurementResult.value.companyAdresStartColumn) {
      formData.append('ExcelWriteConfigDto.CompanyAdresStartColumn', this.measurementResult.value.companyAdresStartColumn);
    }


    // =====================================
    // 2. CİHAZ BİLGİLERİ (GRANÜLER)
    // =====================================
    // CİHAZ ADI
    if (this.measurementResult.value.deviceNameTargetSheetName) {
      formData.append('ExcelWriteConfigDto.DeviceNameTargetSheetName', this.measurementResult.value.deviceNameTargetSheetName);
    }
    if (this.measurementResult.value.deviceNameStartRow) {
      formData.append('ExcelWriteConfigDto.DeviceNameStartRow', this.measurementResult.value.deviceNameStartRow);
    }
    if (this.measurementResult.value.deviceNameStartColumn) {
      formData.append('ExcelWriteConfigDto.DeviceNameStartColumn', this.measurementResult.value.deviceNameStartColumn);
    }

    // SERİ NO
    if (this.measurementResult.value.seriNoTargetSheetName) {
      formData.append('ExcelWriteConfigDto.SeriNoTargetSheetName', this.measurementResult.value.seriNoTargetSheetName);
    }
    if (this.measurementResult.value.seriNoStartRow) {
      formData.append('ExcelWriteConfigDto.SeriNoStartRow', this.measurementResult.value.seriNoStartRow);
    }
    if (this.measurementResult.value.seriNoStartColumn) {
      formData.append('ExcelWriteConfigDto.SeriNoStartColumn', this.measurementResult.value.seriNoStartColumn);
    }

    // ÇÖZÜNÜRLÜK
    if (this.measurementResult.value.resolutionTargetSheetName) {
      formData.append('ExcelWriteConfigDto.ResolutionTargetSheetName', this.measurementResult.value.resolutionTargetSheetName);
    }
    if (this.measurementResult.value.resolutionStartRow) {
      formData.append('ExcelWriteConfigDto.ResolutionStartRow', this.measurementResult.value.resolutionStartRow);
    }
    if (this.measurementResult.value.resolutionStartColumn) {
      formData.append('ExcelWriteConfigDto.ResolutionStartColumn', this.measurementResult.value.resolutionStartColumn);
    }

    // ENVANTER NO
    if (this.measurementResult.value.inventoryNumberTargetSheetName) {
      formData.append('ExcelWriteConfigDto.InventoryNumberTargetSheetName', this.measurementResult.value.inventoryNumberTargetSheetName);
    }
    if (this.measurementResult.value.inventoryNumberStartRow) {
      formData.append('ExcelWriteConfigDto.InventoryNumberStartRow', this.measurementResult.value.inventoryNumberStartRow);
    }
    if (this.measurementResult.value.inventoryNumberStartColumn) {
      formData.append('ExcelWriteConfigDto.InventoryNumberStartColumn', this.measurementResult.value.inventoryNumberStartColumn);
    }

    // TÜR ADI
    if (this.measurementResult.value.kindNameTargetSheetName) {
      formData.append('ExcelWriteConfigDto.KindNameTargetSheetName', this.measurementResult.value.kindNameTargetSheetName);
    }
    if (this.measurementResult.value.kindNameStartRow) {
      formData.append('ExcelWriteConfigDto.KindNameStartRow', this.measurementResult.value.kindNameStartRow);
    }
    if (this.measurementResult.value.kindNameStartColumn) {
      formData.append('ExcelWriteConfigDto.KindNameStartColumn', this.measurementResult.value.kindNameStartColumn);
    }


    // =====================================
    // 3. REFERANS CİHAZLAR LİSTESİ AYARLARI (Granüler)
    // =====================================
    // Cihaz Adı
    if (this.measurementResult.value.referenceDeviceNameTargetSheetName) {
      formData.append('ExcelWriteConfigDto.ReferenceDeviceNameTargetSheetName', this.measurementResult.value.referenceDeviceNameTargetSheetName);
    }
    if (this.measurementResult.value.referenceDeviceNameStartRow) {
      formData.append('ExcelWriteConfigDto.ReferenceDeviceNameStartRow', this.measurementResult.value.referenceDeviceNameStartRow);
    }
    if (this.measurementResult.value.referenceDeviceNameStartColumn) {
      formData.append('ExcelWriteConfigDto.ReferenceDeviceNameStartColumn', this.measurementResult.value.referenceDeviceNameStartColumn);
    }

    // Seri No
    if (this.measurementResult.value.referenceDeviceSeriNoTargetSheetName) {
      formData.append('ExcelWriteConfigDto.ReferenceDeviceSeriNoTargetSheetName', this.measurementResult.value.referenceDeviceSeriNoTargetSheetName);
    }
    if (this.measurementResult.value.referenceDeviceSeriNoStartRow) {
      formData.append('ExcelWriteConfigDto.ReferenceDeviceSeriNoStartRow', this.measurementResult.value.referenceDeviceSeriNoStartRow);
    }
    if (this.measurementResult.value.referenceDeviceSeriNoStartColumn) {
      formData.append('ExcelWriteConfigDto.ReferenceDeviceSeriNoStartColumn', this.measurementResult.value.referenceDeviceSeriNoStartColumn);
    }

    // Kabul Kriteri
    if (this.measurementResult.value.referenceDeviceAcceptanceTargetSheetName) {
      formData.append('ExcelWriteConfigDto.ReferenceDeviceAcceptanceTargetSheetName', this.measurementResult.value.referenceDeviceAcceptanceTargetSheetName);
    }
    if (this.measurementResult.value.referenceDeviceAcceptanceStartRow) {
      formData.append('ExcelWriteConfigDto.ReferenceDeviceAcceptanceStartRow', this.measurementResult.value.referenceDeviceAcceptanceStartRow);
    }
    if (this.measurementResult.value.referenceDeviceAcceptanceStartColumn) {
      formData.append('ExcelWriteConfigDto.ReferenceDeviceAcceptanceStartColumn', this.measurementResult.value.referenceDeviceAcceptanceStartColumn);
    }

    // Belirsizlik
    if (this.measurementResult.value.referenceDeviceUncertaintyTargetSheetName) {
      formData.append('ExcelWriteConfigDto.ReferenceDeviceUncertaintyTargetSheetName', this.measurementResult.value.referenceDeviceUncertaintyTargetSheetName);
    }
    if (this.measurementResult.value.referenceDeviceUncertaintyStartRow) {
      formData.append('ExcelWriteConfigDto.ReferenceDeviceUncertaintyStartRow', this.measurementResult.value.referenceDeviceUncertaintyStartRow);
    }
    if (this.measurementResult.value.referenceDeviceUncertaintyStartColumn) {
      formData.append('ExcelWriteConfigDto.ReferenceDeviceUncertaintyStartColumn', this.measurementResult.value.referenceDeviceUncertaintyStartColumn);
    }

    // --- API CALL ---
    console.log(formData);
    try {
      const res: any = this.data
        ? await this.measurementResultService.updateMeasurementResult(formData)
        : await this.measurementResultService.addMeasurementResult(formData);

      console.log(res);

      if (res.status) {
        this.toastr.success(res.message);
        this.closeModal(true);
      } else {
        this.toastr.error(res.message);
      }
    } catch (error) {
      console.log(error);
      //this.toastr.error(error.message || "Bir hata oluştu");
    } finally {
      this.isSubmitting = false;
    }
  }

  showCreateReferenceDialog() {
    const modal = this.modalService.open(ReferenceTransactionsComponent, {
      size: 'sm',
      backdrop: 'static',
    });
    modal.result.then(async (result) => {
      console.log(result);
      if (result === true) {
        await this.getAllReferences();
      }
    }).catch(() => { })
  }

  closeModal(result: boolean = false) {
    this.ngModal.close(result);
  }

  getSelectedFileName() {
    if (this.selectedFile) {
      return this.selectedFile.name;
    }

    // Güncelleme modunda eski dosya adı varsa GUID kısmını kırp
    if (this.data && this.existingFileName) {
      return this.cleanFileName(this.existingFileName);
    }

    return "Dosya Seç";
  }

  cleanFileName(name: string) {
    // Örnek: "a1b65e5c-1234-5678-9123-0000dosyaadi.pdf"
    const parts = name.split("-");

    // İlk 5 parçayı GUID kabul edip kalanları birleştir
    return parts.slice(5).join("-");
  }

}
